/** The three steps from download to a running computer, and what it needs.
 *  Shown on the home page and beside every download. */

export const STEPS = [
  {
    title: "Download the image",
    body: "One file, about 2.8 GB. The link resumes if the connection drops.",
  },
  {
    title: "Put it on a USB stick",
    body: (
      <>
        Use <a href="https://etcher.balena.io/" target="_blank" rel="noreferrer">balenaEtcher</a> (Windows, Mac or Linux) or{" "}
        <a href="https://rufus.ie/" target="_blank" rel="noreferrer">Rufus</a> (Windows). Choose the image, choose the stick, press Flash. The stick is erased.
      </>
    ),
  },
  {
    title: "Start the computer from it",
    body: "Plug the stick in and restart. Press the boot menu key as it starts (often F12, F9 or Esc) and pick the USB stick. Try Atzmai, then install it when you're ready.",
  },
];

export function Steps() {
  return (
    <ol className="m-0 grid list-none gap-8 p-0 md:grid-cols-3 md:gap-10">
      {STEPS.map((s, i) => (
        <li key={s.title} className="relative flex flex-col gap-2">
          <span aria-hidden="true" className="grid size-10 place-items-center rounded-full border-2 border-ring font-display text-[17px] font-medium text-ink">{i + 1}</span>
          {i < STEPS.length - 1 && <span aria-hidden="true" className="absolute top-5 left-14 hidden h-px w-[calc(100%-3rem)] bg-ring/40 md:block" />}
          <h3 className="mt-2 text-[20px]">{s.title}</h3>
          <p className="text-[16px] text-ink-2">{s.body}</p>
        </li>
      ))}
    </ol>
  );
}

const NEEDS = [
  ["Computer", "A 64-bit Intel or AMD PC or laptop"],
  ["Memory", "4 GB or more (8 GB for the smarter assistant)"],
  ["Storage", "16 GB or more (32 GB is comfortable). Installing erases the disk you choose"],
  ["USB stick", "8 GB or more"],
];

export function Requirements() {
  return (
    <dl className="m-0 grid gap-x-8 gap-y-3 sm:grid-cols-2">
      {NEEDS.map(([what, need]) => (
        <div key={what} className="flex flex-col border-t border-line pt-3">
          <dt className="font-display text-[13px] font-medium text-ink-3">{what}</dt>
          <dd className="m-0 text-ink-2">{need}</dd>
        </div>
      ))}
    </dl>
  );
}
